import { useEffect } from "react";
import { ListingType } from "../../enums/listing/TitleTypes";
import { ShareModalTypes } from "../../interfaces/hooks/IUseShareModalTexts";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useShareContext } from "../../components/training-plan/material";

export const useListingShareModalType = () => {
  const listingType = useSelector(
    (state: RootState) => state.trainingPlan.listingType,
  );
  const { dispatch } = useShareContext();

  useEffect(() => {
    if (listingType == ListingType.ASSESSMENT) {
      dispatch({ type: ShareModalTypes.ASSESSMENT });
      return;
    }

    if (listingType == ListingType.BLOG) {
      dispatch({ type: ShareModalTypes.BLOG });
      return;
    }

    dispatch({ type: ShareModalTypes.WORKOUT });
  }, [listingType]);
};
